/**
 * `?abrir=` — um link de fora (o email da newsletter) pede um modal do app.
 *
 * Mesma mecânica de `reciboDoAviso.ts`, pela mesma razão: o login do Google
 * volta só para o domínio, sem a query string. Quem estava deslogada perderia
 * o pedido no meio do login. Por isso a captura roda no carregamento do
 * módulo, e o pedido espera no `sessionStorage` até o app estar pronto.
 *
 * Só nomes conhecidos passam: um valor qualquer na URL não pode abrir nada.
 */
export const ABRIVEIS = ['newsletter', 'whatsapp', 'banco'] as const;
export type Abrivel = typeof ABRIVEIS[number];

const CHAVE = 'fintracking:abrir';

export const capturarAbrir = (): Abrivel | null => {
  try {
    const url = new URL(window.location.href);
    const pedido = url.searchParams.get('abrir');
    if (!pedido) return null;
    url.searchParams.delete('abrir');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    if (!(ABRIVEIS as readonly string[]).includes(pedido)) return null;
    window.sessionStorage.setItem(CHAVE, pedido);
    return pedido as Abrivel;
  } catch {
    return null;
  }
};

/** Devolve o pedido guardado e o apaga: abre uma vez só. */
export const consumirAbrir = (): Abrivel | null => {
  try {
    const pedido = window.sessionStorage.getItem(CHAVE);
    window.sessionStorage.removeItem(CHAVE);
    return pedido && (ABRIVEIS as readonly string[]).includes(pedido) ? (pedido as Abrivel) : null;
  } catch {
    return null;
  }
};
